import gql from 'graphql-tag';

import { EVENT_CARD_EVENT_FIELDS } from 'app/shared/graphql/events/queries';

export const GET_CITIES = gql`
  query GetCities(
    $citySearch: String
    $topGlobalCity: Boolean
    $topCity: Boolean
    $country: String
    $businessOwner: String
    $city: String
    $cityIds: String
    $isFeaturedSetEnabled: Boolean
    $isAcceptingArtistRequests: Boolean
    $cityOperatingModel: String
    $activeStatus: String
    $orderBy: String
    $orderDirection: String
    $page: Int
    $perPage: Int
    $skipPagination: Boolean
  ) {
    cities(
      citySearch: $citySearch
      topGlobalCity: $topGlobalCity
      topCity: $topCity
      country: $country
      businessOwner: $businessOwner
      city: $city
      cityIds: $cityIds
      isFeaturedSetEnabled: $isFeaturedSetEnabled
      isAcceptingArtistRequests: $isAcceptingArtistRequests
      cityOperatingModel: $cityOperatingModel
      activeStatus: $activeStatus
      orderBy: $orderBy
      orderDirection: $orderDirection
      page: $page
      perPage: $perPage
      skipPagination: $skipPagination
    ) {
      cities {
        id
        title
        cachedSlug
        latitude
        longitude
        cityStatus
        createdAt
        aliases
        cityOperatingModel
        cityOperatingModel
        isAcceptingArtistRequests
        country {
          id
          title
        }
        businessOwner {
          id
          title
          cachedSlug
        }
        neighborhoods {
          id
          title
          cachedSlug
        }
        pastEventsCount
        lastEventAt
        upcomingEventsCount
      }
      metadata {
        totalRecords
        currentPage
      }
    }
  }
`;

export const GET_CITIES_FOR_CITY_SELECTOR = gql`
  query GetCitiesForCitySelector(
    $citySearch: String
    $topGlobalCity: Boolean
    $cityOperatingModel: String
    $activeStatus: String
    $orderBy: String
    $orderDirection: String
    $isLiteQuery: Boolean
  ) {
    cities(
      citySearch: $citySearch
      topGlobalCity: $topGlobalCity
      cityOperatingModel: $cityOperatingModel
      activeStatus: $activeStatus
      orderBy: $orderBy
      orderDirection: $orderDirection
      isLiteQuery: $isLiteQuery
    ) {
      cities {
        id
        title
        cachedSlug
        aliases
        cityOperatingModelDescription
        timezone
        currencyCode
        country {
          id
          title
        }
        artistPaymentMechanism
        audioPaymentMechanism
        supportPaymentMechanism
        nonAudioProductionPaymentMechanism
      }
    }
  }
`;

export const GET_CITIES_FOR_GROUP_BY_BUSINESS_OWNER = gql`
  query GetCitiesForGroupByBusinessOwner(
    $businessOwner: String
    $activeStatus: String
    $isLiteQuery: Boolean
    $cityOperatingModel: String
  ) {
    cities(
      businessOwner: $businessOwner
      activeStatus: $activeStatus
      isLiteQuery: $isLiteQuery
      cityOperatingModel: $cityOperatingModel
    ) {
      cities {
        id
        title
        cachedSlug
        aliases
        latitude
        longitude
        country {
          id
          title
          currencyCode
        }
        businessOwner {
          id
          title
          cachedSlug
        }
      }
    }
  }
`;

export const GET_CITIES_LITE = gql`
  query GetCitiesLite(
    $citySearch: String
    $topGlobalCity: Boolean
    $topCity: Boolean
    $country: String
    $activeStatus: String
    $isLiteQuery: Boolean
  ) {
    cities(
      citySearch: $citySearch
      topGlobalCity: $topGlobalCity
      topCity: $topCity
      country: $country
      activeStatus: $activeStatus
      isLiteQuery: $isLiteQuery
    ) {
      cities {
        id
        title
        cachedSlug
        aliases
        latitude
        longitude
        currencyCode
        country {
          id
          countryCode
          title
          currencyCode
        }
      }
    }
  }
`;

export const GET_CITY = gql`
  query GetCity($id: Int, $cachedSlug: String) {
    city(id: $id, cachedSlug: $cachedSlug) {
      id
      timezone
      title
      cachedSlug
      cityOperatingModel
      description
      whatToExpect
      displayEventFilters
      displayGiftCardPromo
      country {
        id
        title
        cachedSlug
        countryCode
      }
      eventCollections {
        id
        position
        status
        followingsEnabled
        upcomingEventsInCityCount
        title
        description
        cachedSlug
        images {
          header {
            ratio1x1 {
              id
              ratio
              filename
              fileLocation
            }
            ratio16x9 {
              id
              ratio
              filename
              fileLocation
            }
          }
        }
      }
      cityPromotions {
        id
        ctaText
        ctaUrl
        description
        displayEventProperties
        displayEventThemes
        event {
          ...EventCardEventFields
          isPublished
        }
        images {
          header {
            ratio16x9 {
              id
              ratio
              filename
              fileLocation
            }
          }
        }
        inactiveAt
        isActive
        position
        subtitle
        title
      }
      nearbySecondaryCities {
        id
        title
        timezone
        cachedSlug
        currencyCode
        country {
          id
          countryCode
        }
      }
    }
  }
  ${EVENT_CARD_EVENT_FIELDS}
`;

export const GET_CITY_FOR_CLP = gql`
  query GetCityForClp($id: Int, $cachedSlug: String) {
    city(id: $id, cachedSlug: $cachedSlug) {
      id
      title
      cachedSlug
      cityOperatingModelDescription
      aliases
      imageUrl
      latitude
      longitude
      currencyCode
      country {
        id
        title
        cachedSlug
        countryCode
        currencyCode
      }
    }
  }
`;

export const GET_CLOSEST_CITIES = gql`
  query GetClosestCities(
    $count: Int
    $distanceLimit: Int
    $prioritizeOAndOCities: Boolean
    $hasUpcomingEvents: Boolean
    $skipCachedCities: Boolean
  ) {
    closestCities(
      count: $count
      distanceLimit: $distanceLimit
      prioritizeOAndOCities: $prioritizeOAndOCities
      hasUpcomingEvents: $hasUpcomingEvents
      skipCachedCities: $skipCachedCities
    ) {
      cities {
        id
        title
        cachedSlug
        aliases
        description
        cityOperatingModel
        country {
          id
          title
          countryCode
        }
      }
    }
  }
`;
